if (!customElements.get('city-dropdown')) {
  class CityDropdown extends HTMLElement {
    constructor() {
      super();

      this.cityDropdown = this.querySelector("select");
      
      // event listeners
      this.cityDropdown.addEventListener("change", this.cityChanged.bind(this));
      window.addEventListener("locaton:changed", this.locationChanged.bind(this));
      window.addEventListener("custom:cart:loaded-in-cart-page", this.underMinimumValueElem.bind(this));
    }

    connectedCallback() {
      this.underMinimumValueElem();  
    }
    
    cityChanged(e) {
      this.cityDropdown.dataset.selectedLocation = this.cityDropdown.value;
    }

    locationChanged(e) {
      this.cityDropdown.removeAttribute("data-selected-location");
      this.cityDropdown.selectedIndex = 0;
    }

    underMinimumValueElem() {
      const underMinimumValueElem = this.querySelector(".under-minimum-value");
      
      if(!underMinimumValueElem) {
        return
      }
      
      //get cart value
      const cartTotalValue = +document.querySelector(".cart__footer-wrapper .totals .totals__total-value").getAttribute("cart-total");
      
      if( 2000 > cartTotalValue ) {
        underMinimumValueElem.hidden = false;
      }else {
        underMinimumValueElem.hidden = true;
      }
    }
  }

   customElements.define("city-dropdown", CityDropdown);
}